import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircleIcon, AlertTriangleIcon } from 'lucide-react';
const painPoints = ['Viven en "Cese de Fuego" o "Guerra Fría"', 'Se sienten "Compañeros de Cuarto"', 'Están al borde del Divorcio/Separación', 'Tienen "Agotamiento Emocional"', 'Viven con Resentimiento Acumulado', 'Quieren salvar la pareja pero no saben por dónde empezar'];
const benefits = ['Herramientas prácticas para los próximos 7 días', 'Protocolo de comunicación sin peleas', 'Ejercicios de reconexión emocional', 'Guía para sanar heridas del pasado', 'Estrategias para blindar la relación contra crisis externas'];
export function TargetAudienceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#110038] relative" data-id="element-199">
      <div className="max-w-6xl mx-auto px-6" data-id="element-200">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-201">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-202">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 font-serif leading-tight" data-id="element-203">
              Este material va para aquellas personas que:
            </h2>
            <ul className="space-y-4" data-id="element-204">
              {painPoints.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-205">
                  <AlertTriangleIcon className="w-6 h-6 text-[#E5A83B] flex-shrink-0 mt-0.5" data-id="element-206" />
                  <span className="text-[#C4B5FD] text-lg font-sans" data-id="element-207">
                    {point}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: 30
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="bg-[#0D002B] rounded-2xl p-8 md:p-10 border border-[#7C3AED]/30 shadow-[0_10px_30px_-10px_rgba(124,58,237,0.2)]" data-id="element-208">
            <h3 className="text-2xl font-bold text-white mb-6 font-serif" data-id="element-209">
              Lo que vas a lograr:
            </h3>
            <ul className="space-y-5" data-id="element-210">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-211">
                  <CheckCircleIcon className="w-6 h-6 text-[#34D399] flex-shrink-0 mt-0.5" data-id="element-212" />
                  <span className="text-white font-medium font-sans text-lg" data-id="element-213">
                    {benefit}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}